/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : smartMatchingReducer.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author : Abdul Rahim M - abdul@au79consulting.com
 * @Date : 07-02-2025
 * @description
 */
import actionType from "../actionTypes";
const initialState = {
  error: false,
  msg: "",
  smartMatching: [],
  smartMatchingChildVariant: [],
  smartMatchingChildEE: [],
  smartMatchingParentEE: [],
  smartMatchingParentSWM: [],
  smartMatchingChildSWM: [],
  smartMatchingWorflow: [],
};

const smartMatchingReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SMART_RECREATE_PROJECT:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    case actionType.SMART_RECREATE_VARIANT:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };

    case actionType.SMART_RECREATE_EE:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    case actionType.SMART_RECREATE_SWM:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    case actionType.SMART_GET_CHILD_VARIANT:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
        smartMatchingChildVariant: action.payload.error
          ? []
          : action.payload.data,
      };
    case actionType.SMART_GET_CHILD_EE:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
        smartMatchingChildEE: action.payload.error ? [] : action.payload.data,
      };
    case actionType.SMART_GET_PARENT_EE:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
        smartMatchingParentEE: action.payload.error ? [] : action.payload.data,
      };
    case actionType.SMART_GET_PARENT_SWM:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
        smartMatchingParentSWM: action.payload.error ? [] : action.payload.data,
      };
    case actionType.SMART_GET_CHILD_SWM:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
        smartMatchingChildSWM: action.payload.error ? [] : action.payload.data,
      };
    case actionType.SMART_UPDATE_STATUS:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    case actionType.SMART_ADD_WORKFLOW:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    case actionType.SMART_UPDATE_WORKFLOW:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    case actionType.SMART_GET_WORKFLOW:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
        smartMatchingWorflow: action.payload.error ? [] : action.payload.data,
      };
    case actionType.SMART_RECREATE_VS:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    case actionType.SMART_RECREATE_VC:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    default:
      return state;
  }
};

export default smartMatchingReducer;
